"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { AccountSessionMixins } from "@/service/account-session";
import { Component, Mixins, PropSync } from "vue-property-decorator";
let BatchOperateEditGroup = class extends Mixins(
  AccountSessionMixins
) {
  editGroup() {
    this.$emit("editGroup");
  }
  get show() {
    if (this._controller.query.filter.group === "shopgroup_system_recycle") {
      return false;
    } else {
      return true;
    }
  }
};
__decorateClass([
  PropSync("controller")
], BatchOperateEditGroup.prototype, "_controller", 2);
BatchOperateEditGroup = __decorateClass([
  Component
], BatchOperateEditGroup);
export {
  BatchOperateEditGroup as default
};
